<div class="container text-left">
  <div class="container">
    <form [formGroup]="form">
      <h3 class="subtitulo">Processo</h3>
      <div class="form-row">
        <div class="col-7">
          <app-nro-processo-input formControlName="nroProcesso" [tokenIam]="tokenIam" tipoOrdem="REVOGACAO"></app-nro-processo-input>
        </div>
        <div class="d-flex justify-content-center align-items-center col-auto ">
          <button
            mat-button
            [disabled]="!nroProcesso.valid"
            class="btn btn-branco"
            (click)="buscarOrdem()"
            [attr.data-cy]="'button-verificar'"
          >
            Verificar
          </button>
        </div>
      </div>

      <div class="form-dados-ordem" *ngIf="consultaAcaoRealizada">
        <app-sla-selector [form]="form"></app-sla-selector>

        <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"REVOGACAO"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

        <h3 class="subtitulo">Dados para reinclusão</h3>
        <div class="form-row">
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Autor</mat-label>
              <input matInput required placeholder="Autor" formControlName="autor" maxlength="55" noSpecialChars [attr.data-cy]="'input-autor'"/>
              <mat-hint align="end">{{ autor.value?.length }} / 55</mat-hint>
              <mat-error *ngIf="autor.hasError('required')">
                Nome do autor / Exequente é <strong>obrigat&oacute;rio</strong>
              </mat-error>
              <mat-error *ngIf="autor.hasError('valueOnlyNumberError')">
                Nome do autor não pode conter apenas números
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline" class="inputs">
              <mat-label>Réu</mat-label>
              <input matInput required placeholder="Réu" formControlName="reu" maxlength="55" noSpecialChars [attr.data-cy]="'input-reu'"/>
              <mat-hint align="end">{{ reu.value?.length }} / 55</mat-hint>
              <mat-error *ngIf="reu.hasError('required')">
                Nome do réu / executado é <strong>obrigat&oacute;rio</strong>
              </mat-error>
              <mat-error *ngIf="reu.hasError('valueOnlyNumberError')">
                Nome do réu não pode conter apenas números
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row ordem-textarea">
          <div class="col-12">
            <h3 class="subtitulo titulo-descricao">Descrição da Ordem</h3>
            <p class="texto-descricao"> {{ DESCRICAO_ORDEM }} </p>
          </div>
        </div>

        <div class="row buttons-margin-top">
          <div class="col-sm-7"></div>
          <div class="col-sm-5">
            <app-acao-buttons
              [tipoOrdem]="'REVOGACAO'"
              (onConfirmar)="enviarRevogacao()"
            ></app-acao-buttons>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
